/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Clubs_Days_LeftInputs */

const en_us2_clubs_days_left = /** @type {(inputs: Clubs_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} days left`)
};

const pt_br2_clubs_days_left = /** @type {(inputs: Clubs_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faltam ${i?.days} dias`)
};

const es_419_clubs_days_left = /** @type {(inputs: Clubs_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quedan ${i?.days} días`)
};

const pt_pt2_clubs_days_left = /** @type {(inputs: Clubs_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faltam ${i?.days} dias`)
};

const fr_fr2_clubs_days_left = /** @type {(inputs: Clubs_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} jours restants`)
};

const de_de2_clubs_days_left = /** @type {(inputs: Clubs_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noch ${i?.days} Tage`)
};

const it_it2_clubs_days_left = /** @type {(inputs: Clubs_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mancano ${i?.days} giorni`)
};

/**
* | output |
* | --- |
* | "{days} days left" |
*
* @param {Clubs_Days_LeftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_days_left = /** @type {((inputs: Clubs_Days_LeftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Days_LeftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_days_left(inputs)
	if (locale === "es-419") return es_419_clubs_days_left(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_days_left(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_days_left(inputs)
	if (locale === "de-DE") return de_de2_clubs_days_left(inputs)
	if (locale === "it-IT") return it_it2_clubs_days_left(inputs)
	return en_us2_clubs_days_left(inputs)
});
export { clubs_days_left as "clubs.days_left" }